import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { trendingAPI } from '../services/api';
import './TrendingTopics.css';

function TrendingTopics() {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTrending();
  }, []);

  const fetchTrending = async () => {
    try {
      const response = await trendingAPI.getTrendingTopics({ limit: 5 });
      const topicsData = Array.isArray(response.data) ? response.data : [];
      setTopics(topicsData);
    } catch (error) {
      console.error('Error fetching trending topics:', error);
      setTopics([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="trending-widget">
        <h3 className="widget-title">Trending Now</h3>
        <p style={{ padding: '10px', fontSize: '13px', color: '#666' }}>Loading...</p>
      </div>
    );
  }

  if (topics.length === 0) {
    return null; // Don't show widget if no topics
  }

  return (
    <div className="trending-widget">
      <h3 className="widget-title">Trending Now</h3>
      <div className="trending-list">
        {topics.map((topic, idx) => (
          <Link
            key={idx}
            to={`/search?q=${encodeURIComponent(topic.topic)}`}
            className="trending-item"
          >
            <span className="trending-number">{idx + 1}</span>
            <span className="trending-topic">{topic.topic}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default TrendingTopics;